import styled from 'styled-components'
import Typography from '../Typography'

export const Checkmark = styled.span`
  position: absolute;
  left: 0;
  height: 20px;
  width: 20px;

  border: 1.5px ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.neutral.icon.default};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.border.radius.small};

  &::after {
    content: '';
    position: absolute;
    display: none;
    left: 5px;
    width: 5px;
    height: 10px;
    border: ${({ theme }) => theme.border.style.solid}
      ${({ theme }) => theme.neutral.text.inverted};
    border-width: 0 2px 2px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
`

export const Checkbox = styled.input`
  width: 0;
  height: 0;
`

export const Label = styled(Typography).attrs({
  as: 'label',
})<{ alignItems?: string; height?: string }>`
  display: flex;
  align-items: ${({ alignItems }) => alignItems || 'center'};
  height: ${({ height }) => height || '20px'};
  position: relative;
  padding-left: 35px;
  margin: 12px 0 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  color: ${({ theme }) => theme.neutral.text.default};
  font-weight: ${({ theme }) => theme.font.weight.medium};

  padding-left: 28px;
  cursor: pointer;

  ${Checkbox}:checked ~ ${Checkmark} {
    background-color: #0769DA;
    border-color: #0769DA;
  }

  ${Checkbox}:checked ~ ${Checkmark}::after {
    display: block;
  }

  ${Checkbox}:disabled ~ ${Checkmark} {
    border-color: ${({ theme }) => theme.neutral.background.weak};
    cursor: not-allowed;
  }
`
